<div class="ledger-page">
  <div class="pb-2 mb-3 d-flex align-items-center justify-content-between">
    <h3 class="mb-0"><b>{{ selectedCompany?.name || currentCompany?.name }} · Ledger of Additional Data Distribution Points</b></h3>
  </div>

  <div *ngIf="isMckayUser" class="d-flex flex-wrap mb-3">
    <div class="col-12 p-fluid">
      <div class="col-nopad col-6 form-group row">
        <label class="col-4 col-form-label navbar-brand align-self-start"><b>Select company:</b></label>
        <div class="col-7 col-form-input">
          <p-dropdown [(ngModel)]="selectedCompanyId"
                      [filter]="true"
                      [options]="companyOptions"
                      [showClear]="true"
                      [disabled]="loadingCompanies"
                      placeholder="Choose an account"
                      (onChange)="onCompanyChange($event.value)">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="companyError" class="alert alert-danger" role="alert">
    {{ companyError }}
  </div>

  <div *ngIf="isMckayUser && !selectedCompany" class="alert alert-info" role="alert">
    Select a company to display its Ledger of Additional Data Distribution Points.
  </div>

  <ng-container *ngIf="!isMckayUser || selectedCompany">
    <div *ngIf="loading" class="alert alert-info" role="alert">
      Loading ledger information…
    </div>

    <div *ngIf="error" class="alert alert-danger" role="alert">
      Unable to load ledger information right now.
    </div>
<!--
    // WE HIDE THIS SELECT FOR NOW, ASSUMING WE'LL ALWAYS JUST SHOW THE FIRST LEDGER OF THAT COMES, AND THAT IT SHOULD BE THE ONLY ONE…
    <div *ngIf="ledgerOptions.length" class="ledger-selector mb-3 d-flex align-items-center">
      <label class="mb-0 mr-2" for="ledgerSelector">Select ledger:</label>
      <p-dropdown id="ledgerSelector"
                  [options]="ledgerOptions"
                  [(ngModel)]="selectedLedgerId"
                  (onChange)="onLedgerChange($event.value)"
                  appendTo="body"
                  [style]="{width: '500px'}">
      </p-dropdown>
    </div>
-->
    <ng-container *ngIf="!loading && !error">
    <ng-container *ngIf="selectedLedger; else noLedger">
      <div class="card mb-4">
        <div class="card-body">
          <!--<h5 class="card-title mb-3 d-flex align-items-center justify-content-between">
            <span>{{ selectedLedger?.orderForm?.name || selectedLedger?.orderForm?.identificationNumber }}</span>
          </h5>-->
          <div class="row">
            <div class="col-md-4">
              <strong>Order form #</strong>
              <div>{{ selectedLedger?.orderForm?.identificationNumber }}</div>
            </div>
            <div class="col-md-4">
              <strong>Status</strong>
              <div>{{ selectedLedger?.orderForm?.status }}</div>
            </div>
            <div class="col-md-4">
              <strong>MRC</strong>
              <div>{{ selectedLedger?.orderForm?.mrc }}</div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6 col-lg-4">
              <strong>Execution date</strong>
              <div>{{ selectedLedger?.orderForm?.executionDate | date: 'mediumDate' }}</div>
            </div>
            <div class="col-md-6 col-lg-4">
              <strong>End of Order Form date</strong>
              <div>{{ selectedLedger?.orderForm?.terminationDate ? (selectedLedger?.orderForm?.terminationDate | date: 'mediumDate') : 'N/A' }}</div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4">
              <strong>Renewal Term</strong>
              <div>
                <ng-container *ngIf="selectedLedger?.orderForm?.renewalTermRaw as renewalTerm; else noRenewal">
                  {{ renewalTerm }} {{ renewalTerm === 1 ? 'month' : 'months' }}
                </ng-container>
                <ng-template #noRenewal>N/A</ng-template>
              </div>
            </div>
            <div class="col-md-4">
              <strong>Renewal Term start date</strong>
              <div>{{ selectedLedger?.orderForm?.renewalDate | date: 'mediumDate' }}</div>
            </div>
            <div class="col-md-4">
              <strong>Renewal Term end date</strong>
              <div>{{ selectedLedger?.orderForm?.renewalTermEndDate | date: 'mediumDate' }}</div>
            </div>
          </div>
          <div class="row mt-2">
            <div>
              <button class="btn btn-outline-primary btn-sm ledger-download-btn"
                      type="button"
                      [disabled]="!selectedLedger?.orderForm?.id || downloading"
                      (click)="downloadSelectedLedger()">
                {{ downloading ? 'Downloading…' : 'Download PDF' }}
              </button>
              <div *ngIf="downloadError" class="alert alert-danger" role="alert">
                Unable to generate the ledger PDF right now. Please try again later.
              </div>
            </div>
          </div>
          <!-- Temporarily hiding description until we decide whether to keep it -->
          <!--
          <div *ngIf="selectedLedger?.orderForm?.description" class="mt-3 addpof-desc">
            <strong>Description</strong>
            <div [innerHTML]="selectedLedger?.orderForm?.description"></div>
          </div>
          -->
        </div>
      </div>

      <div *ngIf="selectedLedger?.commercialPops?.length" class="mb-4">
        <table class="table table-bordered colocations-table d-inline-table mb-0">
          <thead>
          <tr>
            <th scope="col" colspan="3">CoLocations</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let pop of selectedLedger?.commercialPops || []; trackBy: trackCommercialPop">
            <td>{{ pop.displayId || '-' }}</td>
            <td>{{ pop.name || '-' }}</td>
            <td>{{ pop.address || '-' }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="selectedLedger?.items?.length; else noItems">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" class="align-top sr-only">MDM</th>
            <th scope="col" class="align-top">Data <br/>Center</th>
            <th scope="col" class="align-top">Service <br/>Type</th>
            <th scope="col" class="align-top">Service <br/>Type Ref</th>
            <th *ngIf="canSeeMonthlyFee" scope="col" class="align-top">Monthly <br/>Fee</th>
            <th scope="col" class="align-top">Cross Connect ID</th>
            <th scope="col" class="align-top">Hosted by Third <br/>Party Y/N</th>
            <th scope="col" class="align-top">Commencement <br/>date</th>
            <th scope="col" class="align-top">Removal <br/>date</th>
            <th scope="col" class="align-top">Status</th>
            <th scope="col" class="align-top">Subscriber PO Ref <br/>(optional)</th>
            <th scope="col" class="align-top">Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of selectedLedger?.items || []; trackBy: trackItem"
              [ngClass]="{'pending-addp-row': item.isPendingAddp}"
              [attr.title]="buildPendingTooltip(item)">
            <td class="ledger-mdm-link">
              <a *ngIf="hasMdmLink(item)"
                 class="btn btn-link btn-sm p-0"
                 [href]="getMdmLink(item)"
                 target="_blank"
                 rel="noopener noreferrer"
                 title="Open item in MDM">
                <i class="fa fa-external-link" aria-hidden="true"></i>
                <span class="sr-only">Open item in MDM</span>
              </a>
            </td>
            <td>{{ item.commercialPop || '-' }}</td>
            <td>{{ item.displayServiceLabel || '-' }}</td>
            <td>{{ item.displayService?.toUpperCase() || item.service?.toUpperCase() || '-' }}</td>
            <td *ngIf="canSeeMonthlyFee">{{ formatMonthlyFee(item) }}</td>
            <td>
              <ng-container *ngIf="hasCrossConnectIds(item.crossConnects); else pendingCrossConnect">
                {{ formatCrossConnects(item.crossConnects) }}
              </ng-container>
              <ng-template #pendingCrossConnect>
                <span class="pending-placeholder">Pending</span>
              </ng-template>
            </td>
            <td>{{ hostedByThirdPartyLabel(item) }}</td>
            <td>
              <ng-container *ngIf="item.serviceStartDate; else pendingCommencement">
                {{ item.serviceStartDate | date: 'mediumDate' : 'UTC' }}
              </ng-container>
              <ng-template #pendingCommencement>
                <span class="pending-placeholder">Pending</span>
              </ng-template>
            </td>
            <td>{{ item.serviceEndDate | date: 'mediumDate' : 'UTC' }}</td>
            <td>{{ item.status }}</td>
            <td>{{ item.subscriberPoRef || '-' }}</td>
            <td class="ledger-actions">
              <ng-container *ngIf="item.isPendingAddp; else ledgerItemActions">
                <button type="button"
                        class="btn btn-link btn-sm p-0 mr-2"
                        *ngIf="item.addpRequestId"
                        title="View ADDP request details"
                        (click)="openAddpDetails(item)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                  <span class="sr-only">View ADDP request details</span>
                </button>
                <span *ngIf="isCreationInProgress(item)" class="text-muted">Creation pending…</span>
                <ng-container *ngIf="!isCreationInProgress(item)">
                  <button *ngIf="canCancel(item)"
                          type="button"
                          class="btn btn-link btn-sm text-danger p-0"
                          [disabled]="cancellingRequestId === getCancellationKey(item)"
                          [attr.title]="item.isPendingAddp ? 'Cancel ADDP request' : 'Cancel ADDP'"
                          (click)="openCancelConfirmation(item)">
                    <ng-container *ngIf="cancellingRequestId === getCancellationKey(item); else cancelCreationLabel">
                      <i class="fa fa-spinner fa-spin"></i>
                    </ng-container>
                    <ng-template #cancelCreationLabel>
                      <i class="fa fa-times-circle" aria-hidden="true"></i>
                      <span class="sr-only">Cancel ADDP request</span>
                    </ng-template>
                  </button>
                  <span *ngIf="!canCancel(item)">-</span>
                </ng-container>
              </ng-container>
              <ng-template #ledgerItemActions>
                <ng-container *ngIf="hasPendingCancellation(item); else cancellationStatusBlock">
                  <span class="text-muted">Cancellation pending…</span>
                </ng-container>
                <ng-template #cancellationStatusBlock>
                  <ng-container *ngIf="isCancellationCompleted(item); else cancellationAction">
                    <span class="text-success">Cancelled</span>
                  </ng-container>
                  <ng-template #cancellationAction>
                    <button type="button"
                            class="btn btn-link btn-sm p-0 mr-2"
                            *ngIf="item.addpRequestId"
                            title="View ADDP request details"
                            (click)="openAddpDetails(item)">
                      <i class="fa fa-eye" aria-hidden="true"></i>
                      <span class="sr-only">View ADDP request details</span>
                    </button>
                    <button *ngIf="canCancel(item)"
                            type="button"
                            class="btn btn-link btn-sm text-danger p-0"
                            [disabled]="cancellingRequestId === getCancellationKey(item)"
                            title="Cancel ADDP"
                            (click)="openCancelConfirmation(item)">
                      <ng-container *ngIf="cancellingRequestId === getCancellationKey(item); else cancelLabel">
                        <i class="fa fa-spinner fa-spin"></i>
                      </ng-container>
                      <ng-template #cancelLabel>
                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                        <span class="sr-only">Cancel ADDP</span>
                      </ng-template>
                    </button>
                    <span *ngIf="!canCancel(item)">-</span>
                  </ng-template>
                </ng-template>
              </ng-template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noItems>
        <div class="alert alert-secondary" role="alert">
          No ledger items are associated with this order form yet.
        </div>
      </ng-template>
    </ng-container>
    <ng-template #noLedger>
      <div class="alert alert-secondary" role="alert">
        No ledger order forms have been found for this company.
      </div>
    </ng-template>
  </ng-container>
  </ng-container>
</div>

<p-dialog [(visible)]="addpDetailsVisible"
          [modal]="true"
          [dismissableMask]="true"
          [closeOnEscape]="true"
          [style]="{ width: '720px' }"
          (onHide)="onAddpDetailsVisibilityChange(false)">
  <ng-template pTemplate="header">
    <div class="addp-details-dialog-header">
      <div class="addp-details-dialog-title">{{ getAddpDetailsDialogTitle() }}</div>
      <div class="addp-details-dialog-subtitle" *ngIf="getAddpDetailsRequesterLine(selectedAddpDetails) as requesterLine">
        {{ requesterLine }}
      </div>
    </div>
  </ng-template>
  <div *ngIf="loadingAddpDetails" class="alert alert-info mb-0">
    Loading ADDP request details…
  </div>

  <div *ngIf="addpDetailsError" class="alert alert-danger mb-0">
    {{ addpDetailsError }}
  </div>

  <ng-container *ngIf="!loadingAddpDetails && !addpDetailsError">
    <ng-container *ngIf="selectedAddpDetails as details">
      <div class="addp-details-card">
        <div class="addp-details-title">
          {{ formatAddpDetailsTitle(details) }}
          <span class="item-service">{{ getAddpDetailsService(details) }}</span>
        </div>
        <p class="addp-details-meta" *ngIf="getAddpDetailsOriginalXco(details) as originalXco">
          <span class="original-xco-label">Original XCO : {{ originalXco }} ·</span>
          <span *ngIf="getAddpDetailsTechnicalPopName(details) as technicalPopName">&nbsp;{{ technicalPopName }}</span>
        </p>
        <p class="addp-details-products">{{ formatAddpDetailsProducts(details) }}</p>
      </div>
    </ng-container>
  </ng-container>
</p-dialog>
